import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { componentCreated, updateDateFilter, updateGroupFilter } from '../Redux/Actions/DateFilter'
import {
  composeFilterString,
  formatStartEndDates,
  getDateFilter, getGroupFilter,
  processDate,
  processGroup
} from '../utils/analytics-utils'
import { fetchSmsHistory, fetchSmsUser } from '../Redux/Actions/Sms'
import SmsHistoryTable from '../Shared/Data/SmsHistoryTable'
import { addQuery } from '../utils/router-utils'
import SubHeader from '../Shared/Display/SubHeader'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import FilterBy from '../Shared/Filters/FilterBy'
import BackArrow from '../Shared/Icons/icon-backarrow-grey.svg'
import { numberedDate } from '../Shared/timeutils'
import { formatPhoneNumber } from '../Shared/stringUtils'
import { Link } from 'react-router-dom'

const statusStrings = {
  'OPTED-IN': 'Opted-In',
  'OPTED-OUT': 'Opted-Out',
  'PENDING INVITE': 'Pending Invite',
  'PENDING RESPONSE': 'Pending Response',
  PENDING: 'Pending'
}

function SmsHistory () {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const pageTotals = 5
  const [page, setPage] = useState(1)

  const id = useSelector(state => state.account.ID)
  const userAnalyticsEnabled = useSelector(state => state.account.userAnalyticsEnabled)
  const redirect = useSelector(state => state.account.redirect)
  const sms = useSelector(state => state.sms)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'SmsHistory'

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilterFromStore = getGroupFilter(dateFilterStore, name) || ''
  const [groupFilter, setGroupFilter] = useState(groupFilterFromStore)
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    update(processDate(dateFilter), processGroup(groupFilter))
  }, [page])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const update = (date, group, newID) => {
    const formattedDate = formatStartEndDates(date)
    const ID = newID || id
    const searchQ = location.search.substring(1).split('&')
    searchQ.forEach((q) => {
      searchQ[q.split('=')[0]] = q.split('=')[1]
    })
    dispatch(fetchSmsUser(ID, searchQ.id))
    dispatch(fetchSmsHistory(ID, searchQ.id, formattedDate.start, formattedDate.end, {
      limit: pageTotals,
      offset: (page - 1) * pageTotals,
      sourceType: group.alt
    }))
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  const changeGroupFilter = (newFilter) => {
    let newDateFilter
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }

    dispatch(updateGroupFilter(name, newFilter))
    const f = `${composeFilterString(newFilter.profiles, newFilter.groups)}_${newFilter.alt || ''}`
    addQuery({ date: newDateFilter, filter: f }, location, navigate)
    setGroupFilter(newFilter)
    update(processDate(newDateFilter), processGroup(newFilter))
  }

  if (userAnalyticsEnabled) {
    return (
      <div id='SmsHistoryPage'>
        <div className='button-cursor' onClick={() => navigate(-1)}>
          <img src={BackArrow} className='interactive' alt='back' />
        </div>
        <div>
          <h2 style={{ fontWeight: 'bold' }}>Regcode: {sms.user.regcode}</h2>
          <h2>User Name: {sms.user.name ? <Link to={{ pathname: '/user', search: '?id=' + sms.user.userId + '&date=Week&filter=__' }}>{sms.user.name}</Link> : 'Not Available'}</h2>
          <h2>Phone number: {formatPhoneNumber(sms.user.phoneNumber)}</h2>
          <h2>Status: {statusStrings[sms.user.status] || ''}</h2>
          <h2>Updated on: {sms.user.updatedOn ? numberedDate(sms.user.updatedOn) : ''}</h2>
        </div><br />
        <div className='toolbar'>
          <SubHeader type='SmsHistory' value='SMS History' />
          <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
        </div>
        {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month') ? <CustomFilter filterBy={changeDateFilter} currentFilter={dateFilter} /> : ''}
        <FilterBy changeFilter={changeGroupFilter} currentFilter={processGroup(groupFilter)} type='Source' />
        <SmsHistoryTable
          title='SMS Audit Trail'
          data={sms.history || []}
          fields={[{ ref: 'title', title: 'Title' },
            { ref: 'status', title: 'Status' },
            { ref: 'timestamp', title: 'Timestamp' }]}
          changeOffset={(i) => {
            setPage(i)
          }}
          page={page}
          totalPages={Math.ceil(sms.smsHistoryLength / pageTotals)}
          showTooltip
          tooltipText='An overview of SMS messages sent and received within the system for this user.'
        />
      </div>
    )
  } else {
    return (
      <div className='SmsHistoryTable'>
        <div className='adminPage'>
          <p>Push notifications analytics have not been turned on. To do so, go to Master Administrator Account Settings and enable User Analytics</p>
        </div>
        <div className='adminPageContainer'><a className='buttonRedirect' href={redirect}>Go to Master Administrator Account Settings</a></div>
      </div>
    )
  }
}

export default SmsHistory
